import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Role } from 'src/app/core/models/role';
import { AuthService } from 'src/app/core/services/auth.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { FilialService } from 'src/app/core/services/filial.service';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
  selector: 'app-filial-admin-form',
  templateUrl: './filial-admin-form.component.html',
  styleUrls: ['./filial-admin-form.component.css']
})
export class FilialAdminFormComponent implements OnInit {
  user: any = {};
  isLoading = false;
  isLoadingForm = false;
  companyId: string;
  currentUser: any;

  constructor(
    private translate: TranslateService,
    private filialService: FilialService,
    private authService: AuthService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });
    console.log(this.currentUser)
    this.route.parent.params.subscribe((res) => {
      this.companyId = res.id;
    });
    console.log(this.companyId)
  }

  addAdmin(form: NgForm) {
    let body = {};

    if (!form.valid) {
      this.translate.get('global.requiredFields').subscribe((res: string) => {
       // this.toastr.error(res);
      });
      return false;
    }

    Object.entries(form.form.value).forEach(([key, value], index) => {
      if (value) {
        body[key] = value;
      }
    });

    // this.user = {
    //   name: null,
    //   email: null
    // };

    this.isLoadingForm = true;
    console.log(body)
    this.filialService.createFilialAdmin(this.companyId, body).subscribe(
      (res) => {
        console.log(res)
        this.isLoadingForm = false;

      },
      (err) => {
        this.isLoadingForm = false;
       // this.toastr.error(err.error.description);
       console.log(err)
      }
    );

  }

}
